import classes from "../../TwoFactorAuth.scss";
import {getLocalizedStringstwo} from'../../twoFactorAuthenticationStrings';
import SceTextBox from "../../common/TwoFactorVerifyTextBox";
import RadioGroup from "../../../LanguageRadioGroup";
import SceButton from  "../../../../../Common/CommonComponents/sceButton";

function EmailStepTwo(props) {
    let strings = getLocalizedStringstwo('TwoFactorAuthentication');
    let TEXT_EMAIL_PIN = 6;
    let warningImg = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
    const invalidCodeErrormsg =  props.invalidCodeError ? <div className={classes.invalidCodeErrorSection}> <img src={warningImg} alt="invalidCoderror" /><span className={classes.invalidCodeErrormsg}>  {strings.invalidCodeError}</span></div>: '';
    const resendExceedMsg= props.resendExceedMsg ?
                <div className={["sce-content-row", 'sce-center-alg'].join(" ")}><a className={classes.disabledSendCode}> {strings.resendCode}</a> <br />
                    <span><img src={warningImg} alt="Warning Image" /></span>
                    <span className={classes.errMsg}> {props.resendExceedMsg}</span>
                </div>
                :
                <div className={classes.centeraligned}> <a className={classes.sendCode}   href="JavaScript:void(0)" onClick={props.resendCodeHandle}> {strings.resendCode}</a></div>;
    const tryAgain = !props.resendSuccess ?
                <div className={"sce-content-row"}>
                    <div className={classes.errorContainer}>
                        <div> <img src={warningImg} alt="Warning Image" /> </div>
                        <div className={["sce-caret", classes.errMsg].join(" ")}>
                            {strings.tryAgain}
                        </div>
                    </div>
                </div>
                : null;         
                
     return (
        <div className={classes.stepTwoText}>
        <div className={classes.enterVerifyCode}>
            <div className={classes.enterVerifyCodeContainer}>
                <div className={[classes.verifyLogIn,classes.verifyLogInFlex, 'sce-center-alg'].join(" ")}> {strings.enterVerificationCode}
                    <div className={[classes.verifyAddress, "sce-content-row"].join(" ")}> {props.maskedValue}
                    </div>
                </div>
                <div className={["sce-content-row",classes.subTextCodeReceived].join(" ")}>  {strings.emailVerification}
                    <div className={["sce-content-row",classes.verificationCode,classes.verificationCodeFontSize].join(" ")}> {strings.verificationCode}
                        <div className={classes.verificationCodeMarginTop}>
                            <SceTextBox
                                type={"verificationCodeSms"}
                                id={'verificationCode'}
                                validator={app.appUtil.validator}
                                maxLength={TEXT_EMAIL_PIN}
                                onChangeVerifyHandler={props.onChangeHandler}
                            />
                        </div>
                        {invalidCodeErrormsg}
                        <div className={["sce-content-row",'sce-center-alg',classes.verifyBtn,classes.verifyBtnMarginTop].join(" ")}>
                        <SceButton id='VerfiyCode' isDisabled={(props.disableVerifyBtn) ? true : false} buttonType={(props.disableVerifyBtn) ?'sceDisabled' : 'primary'} value={strings.verify} onClick={props.verifyCodeHandler} />
                          </div>
                        {resendExceedMsg}
                        {tryAgain}
                        
                    </div>
                </div>
            </div>
               
        </div>
        </div>
    );
}

export default EmailStepTwo;
